// extracted by mini-css-extract-plugin
module.exports = {"root":"_1ph1Njg","input":"_2EhwaDE","suggestionsContainer":"_2FRo-8-","suggestionPartMatch":"_1DnXBxV","suggestionPart":"_2ClbbY5"};
    if(module.hot) {
      // 1545369445222
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  